import React, { useCallback, useState, useRef, useEffect, useMemo } from 'react';
import '../ProductOverview';
import ProductOverview from '../ProductOverview';
import DotNav from '../../DotNav/DotNav';
import { Waypoint } from 'react-waypoint';
import PropTypes from 'prop-types';
import { minimum } from '../../../adapters/helpers/functions';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper';

export default function CarrouselProductsOverview({
    products,
    whiteText,
    onClickCallback,
    productOverview,
    isMedium,
    removeLazyLoad,
    isArticle,
    rightArrowIconArticle,
    leftArrowIconArticle,
}) {
    const [currentPage, setCurrentPage] = useState(0);
    const productGridRef = useRef(null);
    const [isShown, setIsShown] = useState(false);

    const handleDotClick = useCallback((i) => {
        if (productGridRef.current) {
            const nextY = productGridRef.current.clientWidth * i;
            if (productGridRef.current.scrollTo) {
                productGridRef.current.scrollTo({ left: nextY, behavior: 'smooth' });
            } else {
                productGridRef.current.scrollLeft = nextY;
            }
        }
    }, []);

    const swiperRef = useRef(null);
    useEffect(() => {
        if (productGridRef.current) {
            productGridRef.current.scrollLeft = 0;
            setCurrentPage(0);
        }
    }, [productGridRef.current]);

    const handleWaypoint = useCallback(() => {
        setIsShown(true);
    }, []);

    const minimumAspectRatio = useMemo(() => {
        const aspectRatio = minimum(
                products.map(product => product?.fields?.mainAsset?.fields?.imageRendition?.fields?.aspectRatio)
        );
        // Temporary while aspect Ratios are too extreme
        return aspectRatio && Math.max(aspectRatio, 0.4);
    }, [products]);

    return (
        <>
            <Waypoint onEnter={handleWaypoint} topOffset={'500px'} bottomOffset={'300px'}>
                <div ref={productGridRef} className="ob-carrousel-products-overview">
                    <button className="custom-prev-button px-1" id="custom-prev-button">
                        <img
                            src={`https:${leftArrowIconArticle?.fields?.asset?.fields?.file?.url}`}
                            alt={leftArrowIconArticle?.fields?.alternateText || 'Previous'}
                            className='w-7 h-6'
                            width={7}
                            height={6}
                        />
                    </button>

                    <Swiper
                        spaceBetween={50}
                        slidesPerView={1}
                        pagination={false}
                        navigation={{
                            prevEl: '#custom-prev-button',
                            nextEl: '#custom-next-button',
                        }}
                        modules={[Pagination, Navigation]}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                        onSlideChange={(swiper) => setCurrentPage(swiper.activeIndex)}
                    >
                        {products.map((product, i) => (
                            <SwiperSlide key={i}>
                                <div className={`ob-carrousel-products-overview-item ${isArticle ? 'product-item border border-revamp_product_brdr rounded-xl mb-0' : ''}`}>
                                    <ProductOverview
                                        key={i}
                                        product={product}
                                        whiteText={whiteText}
                                        index={i}
                                        aspectRatio={minimumAspectRatio}
                                        isShown={isShown}
                                        isAutoHeightMode={false}
                                        isAnimated={true}
                                        onClickCallback={onClickCallback}
                                        isMedium={isMedium}
                                        removeLazyLoad={removeLazyLoad}
                                        productOverview={productOverview}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    <button className="custom-next-button px-1" id="custom-next-button">
                        <img
                            src={`https:${rightArrowIconArticle?.fields?.asset?.fields?.file?.url}`}
                            alt={rightArrowIconArticle?.fields?.alternateText || 'Next'}
                            className='w-7 h-6'
                            width={7}
                            height={6}
                        />
                    </button>
                </div>
            </Waypoint>
            {products.length > 1 && !isArticle &&
                <div>
                    <DotNav
                        className="ob-product-grid__progress-bar"
                        onClick={handleDotClick}
                        count={products.length}
                        current={currentPage}
                    />
                </div>}
        </>
    );
}

CarrouselProductsOverview.defaultProps = {
    products: [],
}

CarrouselProductsOverview.propTypes = {
    products: PropTypes.array,
    whiteText: PropTypes.bool,
    onClickCallback: PropTypes.func,
    productOverview: PropTypes.any,
    isMedium: PropTypes.bool,
    removeLazyLoad: PropTypes.bool,
}
